import type { Seo } from '@sravni/types/lib/seo';

interface IMetadataState {
  seo: Seo;
  pathname: string;
}

export const prepareMetadataState = (params: IMetadataState): IMetadataState => {
  const { seo, pathname } = params;

  const canonical = `https://www.sravni.ru${pathname}`;

  const preparedSeo = {
    ...seo,
    canonical,
  };

  return {
    seo: preparedSeo,
    pathname,
  };
};
